import { encrypt } from '../helpers/Helpers';

export default async function VerifyPIN({ crewCode, pin }) {
  // Encriptar el PIN antes de enviar
  const encryptedPin = encrypt(pin, process.env.REACT_APP_KEY);

  const url = "https://gops.azulhandling.com/LoginPage/procesos_seguros/VerifyPIN.php";
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-API-KEY': localStorage.getItem('token') || ''
    },
    body: JSON.stringify({ 
      crewCode, 
      pin: encryptedPin 
    })
  });
  if (res.status === 200) {
    return await res.text();
  } else {
    return "Error verificando el PIN";
  }
}
